import './theme.css';
import './fp3-app';

const platform = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform
  || navigator.platform
  || '';
if (/win/i.test(platform)) document.documentElement.classList.add('os-windows');

const nativeFetch = window.fetch.bind(window);
window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  const response = await nativeFetch(input, init);
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  const path = url.startsWith('http') ? new URL(url).pathname : url;
  if (response.status === 401 && path.startsWith('/api/') && !path.startsWith('/api/auth/')) {
    window.dispatchEvent(new Event('fp3-unauthorized'));
  }
  return response;
};
